import React from "react"
import Treatment from "../components/tratment/treatment"

import Layout from "../components/layout"
import SEO from "../components/seo"
import image from "../images/waxing1.jpg"

const description = (
  <div>
    <p>We are providing also waxing services, eyelash and eyebrows tinting.</p>
    <p>We are using 2 types of wax:</p>
    <ul>
      <li>
        Stripless hot wax with flexible, super grip technology. Perfect for
        face, underarm and bikini. Super gentle multidirectional technique for
        less pain.{" "}
      </li>
      <li>
        High performance, soft wax roller cartridges. Perfect for quick, speedy,
        clean and effective treatments.{" "}
      </li>
    </ul>
    <p>
      Whether you want a quick leg wax or you want your underarm hair to
      disappear we have developed a set of waxing techniques to make the process
      quick & painless. Book Your Waxing Today.
    </p>
  </div>
)

const Waxing = () => (
  <Layout>
    <SEO title="Waxing" />
    <Treatment image={image} title="Waxing" htmlText={description} />
  </Layout>
)

export default Waxing
